import { render, staticRenderFns } from "./depositlist.vue?vue&type=template&id=3f8f2870"
import script from "./depositlist.vue?vue&type=script&lang=js"
export * from "./depositlist.vue?vue&type=script&lang=js"
import style0 from "./depositlist.vue?vue&type=style&index=0&id=3f8f2870&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports